import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrButtonModule } from '../pr-button/pr-button.module';
import { PrButtonConfirmComponent } from './pr-button-confirm.component';
import { PrModalModule } from '../../pr-modal/pr-modal.module';

@NgModule({
  imports: [CommonModule, PrButtonModule, PrModalModule],
  exports: [PrButtonConfirmComponent],
  declarations: [PrButtonConfirmComponent],
})
export class PrButtonConfirmModule {}
